import { useTranslation } from "next-i18next";
import Image from "next/image";
import { FC } from "react";
import { Container } from "~/components/Container";
import { Features } from "~/constants/data";
import Trans from "~/types/translationKeys";
import styles from "./WhyChooseCXGenie.module.scss";

const WhyChooseCXGenie: FC = () => {
  const { t } = useTranslation();

  return (
    <section className={styles.why_choose_cx_genie} id="why_choose_cx_genie">
      <Container className={styles.container}>
        <h3 className={styles.title}>{t(Trans.why_choose_cx_genie)}</h3>

        <div className={styles.features}>
          {Features.map((item) => (
            <div key={item.name} className={styles.feature_item}>
              <Image
                src={item.image}
                alt={t(item.name)}
                width={48}
                height={48}
              />
              <h4 className={styles.name}>{t(item.name)}</h4>
              <p className={styles.content}>{t(item.content)}</p>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default WhyChooseCXGenie;
